import React from 'react'

const CustomSeoBox = (props) => {
    return (
        <>
            <div className="col-md-4">
            <div className="custom-box mt-5  p-3 rounded seo-box project">
                <img src={process.env.PUBLIC_URL + (props.img)} className="seo-img mb-3"/>
                <h3>{props.head}</h3>
                <p className="text-justify">{props.para}</p>
</div>
            </div>
        </>
    )
}

export default CustomSeoBox
